import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingChange';

import { loadDialog } from './utils';

export default function* listenLoadDialog() {
  yield takeEvery(actions.loadDialog.toString(), loadDialog);
}
